export const isOverrideVersion = (
  systemRating: number | undefined,
  overrideRating: number | undefined,
): boolean => {
  return (Boolean(overrideRating) && overrideRating !== systemRating) ?? false;
};

export const getDepartmentRating = (
  systemRating: number | undefined,
  overrideRating: number | undefined,
  defaultValue?: number,
): number => {
  const isOverride = isOverrideVersion(systemRating, overrideRating);
  const value = defaultValue ?? 0;

  return isOverride
    ? (overrideRating ?? systemRating ?? value)
    : (systemRating ?? value);
};
